
import React from 'react';
import { Alert, AlertTitle, AlertDescription } from '@/components/ui/alert';
import { XCircle } from 'lucide-react';
import { cn } from '@/lib/utils';

interface ErrorAlertProps {
  title?: string;
  description: string;
  className?: string;
  onRetry?: () => void;
}

/**
 * Componente per mostrare un messaggio di errore in un formato standard
 */
export function ErrorAlert({ 
  title = "Errore", 
  description, 
  className,
  onRetry
}: ErrorAlertProps) {
  return (
    <Alert variant="destructive" className={cn("my-4", className)}>
      <XCircle className="h-4 w-4 mr-2" />
      {title && <AlertTitle>{title}</AlertTitle>}
      <AlertDescription>{description}</AlertDescription>
      
      {onRetry && (
        <button
          onClick={onRetry}
          className="text-sm underline mt-2 hover:text-[var(--textPrimaryColor)]"
        >
          Riprova
        </button>
      )}
    </Alert>
  );
}
